import MenuToggle from "./modules/MenuToggle";
import ExpanderImage from "./modules/ExpanderImage";
import HorizontalScroller from "./modules/HorizontalScroller";
import Carousel from "./modules/Carousel";
import addClass from "./functions/addClass";
import removeClass from "./functions/removeClass";

export default class App {
    constructor() {}

    run() {
        ((menuToggles) => {
            Array.from(menuToggles).forEach((menuToggle) => {
                new MenuToggle(menuToggle);
            });
        })(document.getElementsByClassName('menu-toggle'));

        ((expanderImages) => {
            Array.from(expanderImages).forEach((expanderImage) => {
                new ExpanderImage(expanderImage);
            });
        })(document.getElementsByClassName('expander-image'));

        ((movers) => {
            Array.from(movers).forEach((mover) => {
                new HorizontalScroller(mover);
            });
        })(document.getElementsByClassName('horizontal-mover'));

        ((homeCarousels) => {
            Array.from(homeCarousels).forEach((homeCarousel) => {
                new Carousel(homeCarousel, {
                    autoPlay: parseInt(homeCarousel.getAttribute('data-delay')),
                    pauseAutoPlayOnHover: true,
                    draggable: '>1',
                    fade:true,
                    prevNextButtons: false
                } );
            });
        })(document.getElementsByClassName('home-carousel'));

        ((flowerCarousels) => {
            Array.from(flowerCarousels).forEach((flowerCarousel) => {

                new Carousel(flowerCarousel, {
                    pageDots: false ,
                    fade:true,
                    imagesLoaded: true,
                    autoPlay: parseInt(flowerCarousel.getAttribute('data-delay')),
                    pauseAutoPlayOnHover: true,
                    wrapAround: true,
                    prevNextButtons: true,
                    setGallerySize:false,
                } );
            });
        })(document.getElementsByClassName('flower-carousel'));

        ((flowerThumbCarousels) => {
            Array.from(flowerThumbCarousels).forEach((flowerThumbCarousel) => {
                new Carousel(flowerThumbCarousel, {
                    asNavFor : ".carousel-main",
                    contain : true,
                    pageDots: false ,
                    imagesLoaded: true,
                    autoPlay :false,
                    pauseAutoPlayOnHover: true,
                    prevNextButtons: false

                } );
            });
        })(document.getElementsByClassName('flower-thumbnail-carousel'));

        ((notes, payButton, warningMsg)=> {
            if (notes) {
                notes.addEventListener('keyup', function (e) {
                    console.log(e);
                    console.log(notes.value);
                    if (notes.value.length > 0) {
                        payButton.disabled = true;
                        removeClass(warningMsg, 'hidden');
                    } else {
                        payButton.disabled = false;
                        addClass(warningMsg, 'hidden');
                    }
                });
            }
        })(document.getElementById('form1_c_order_var_notes'), document.getElementById('btnCheckout'), document.getElementById('payment-warning'))
    }
}


